module.exports = __webpack_public_path__ + "img/expenses-white.29579cbe.svg";